module.exports = __webpack_public_path__ + "img/ai-6.a2cec05b.jpg";